import type { History } from 'history';
import { createBrowserHistory } from 'history';
import { getBootBasename } from './boot';
import { getLocaleFromPath } from './paths';

let history: History | undefined;

// Locale prefix as basename: navigate/redirect add it, route pathnames stay locale-free.
export const getHistory = (): History => {
  if (!history) {
    history = createBrowserHistory({ basename: getBootBasename() });
  }
  return history;
};

const isExternalHref = (href: string) =>
  href.includes('://') ||
  href.startsWith('//') ||
  href.startsWith('mailto:') ||
  href.startsWith('tel:');

// For hrefs outside navi; external, relative and already-prefixed hrefs pass through.
export const localizeHref = (href: string): string => {
  if (!href.startsWith('/') || isExternalHref(href)) return href;
  if (getLocaleFromPath(href)) return href;

  return `${getBootBasename()}${href}`;
};
